module.exports = __webpack_public_path__ + "videos/tile-effects_en.76c00b7.mp4";